import { sessaoFetch, sessaoFetchLoading } from '../service/fetch'
import { serialize } from '@/service/util'

export async function getListas (dados) {
  return sessaoFetchLoading(`consig`, `/listagens/ListarPaginadoEnvelopado?` + serialize(dados), 'GET')
}

export async function get (id) {
  return sessaoFetchLoading(`consig`, `/listagens/GetDetalhadoEnvelopado/${id}`, 'GET')
}

export async function getUsuarios (id) {
  return sessaoFetchLoading(`consig`, `/listagens/GetUsuariosEnvelopado/${id}`, 'GET')
}

export async function add (dados) {
  return sessaoFetchLoading(`consig`, `/listagens/CriarCompletoEnfileirado`, 'POST', dados)
}

export async function del (id) {
  return sessaoFetchLoading(`consig`, `/listagens/DeletarEnfileirado/${id}`, 'DELETE')
}

export async function editStatus (dados) {
  return sessaoFetchLoading(`consig`, `/listagens/updateativoenvelopado`, 'PUT', dados)
}

export async function usuarioGrupos () {
  return sessaoFetch(`base`, `/campanha/usuario/grupo`)
}

export async function usuarioListagem (id) {
  return sessaoFetch(`base`, `/campanha/usuario/${id}/listagem`)
}

export async function usuarioListagens (id) {
  return sessaoFetch(`base`, `/campanha/usuario/listagens`)
}

export async function usuarioItens (id) {
  return sessaoFetchLoading(`base`, `/campanha/usuario/listagem/${id}`)
}

export async function listPorUnidade (unidade) {
  return sessaoFetchLoading(`base`, `/listagem/unidade/${unidade}`)
}

export async function importarClientesParaCampanha (clientes) {
  return sessaoFetchLoading('consig', '/campanhas/ImportarClientesParaCampanha', 'POST', clientes)
}

export async function exportar (payload) {
  return sessaoFetchLoading(`consig`, `/listagens/ExportarCSVEnfileirado/${payload.id}`, 'GET')
}

export async function editarUsuarios (dados) {
  return sessaoFetchLoading(`consig`, `/listagens/EditarUsuariosEnvelopado`, 'POST', dados)
}



// WEBPACK FOOTER //
// ./src/api/listagem.js